import o, { useCallback as f } from "react";
import { Button as _ } from "../button/basic-button.esm.js";
import p from "../icon/src/ChevronLeft.esm.js";
import u from "../icon/src/ChevronRight.esm.js";
import { ScreenReaderOnly as E } from "../utils/sr-only.esm.js";
import { s as v } from "../pagination.button.module-zVI0JV1c.mjs";
import { NEXT_PAGE as d, PREVIOUS_PAGE as C } from "./utils.esm.js";
const h = /* @__PURE__ */ o.createElement(p, null), N = /* @__PURE__ */ o.createElement(u, null), y = ({
  variant: r,
  currentPage: t,
  dataTestId: l = "fuse-pagination",
  totalPages: m,
  onClick: n,
  href: a
}) => {
  const e = r === "next", s = f(
    (i) => {
      if (a && i.preventDefault(), n) {
        const c = e ? t + 1 : t - 1;
        n(i, c);
      }
    },
    [n, e, t, a]
  );
  return /* @__PURE__ */ o.createElement(
    _,
    {
      icon: e ? N : h,
      onClick: s,
      fullWidth: !1,
      variant: "tertiary",
      disabled: e ? t === m : t === 1,
      href: a,
      className: `${v.pagination__chevronButton} fuse-pagination__chevron-button`,
      "data-testid": `${l}__chevron-button`
    },
    /* @__PURE__ */ o.createElement(E, null, e ? d : C)
  );
};
export {
  y as ChevronButton
};
